module.exports = __webpack_public_path__ + "img/13.5ce857e2.png";